import { relations } from 'drizzle-orm';
import { boolean, pgTable, text, uuid } from 'drizzle-orm/pg-core';
import { addresses } from './addresses.js';
import { user } from './auth.js';
import { pharmacies } from './pharmacies.js';
import { timestamps } from './utils/index.js';
import { resourceStatus } from './utils/resource-status.js';
import { userActions } from './utils/user-actions.js';
import { uuidv7 } from './utils/uuidv7.js';
export const customers = pgTable('customer', {
    id: uuidv7('id').primaryKey(),
    name: text('name').notNull(),
    pharmacyId: uuid('pharmacy_id')
        .notNull()
        .references(() => pharmacies.id, { onDelete: 'cascade' }),
    email: text('email'),
    phone: text('phone'),
    isSameAddress: boolean('is_same_address').default(true),
    status: resourceStatus('status').default('active'),
    ikNumber: text('ik_number').notNull().unique(),
    producerNumber: text('producer_number'),
    labelName: text('label_name'),
    addressId: uuid('address_id').references(() => addresses.id, { onDelete: 'set null' }),
    deliveryAddressId: uuid('delivery_address_id').references(() => addresses.id, { onDelete: 'set null' }),
    ...timestamps(),
    ...userActions(),
});
export const customerRelations = relations(customers, ({ one }) => ({
    pharmacy: one(pharmacies, {
        fields: [customers.pharmacyId],
        references: [pharmacies.id],
    }),
    address: one(addresses, {
        fields: [customers.addressId],
        references: [addresses.id],
    }),
    deliveryAddress: one(addresses, {
        fields: [customers.deliveryAddressId],
        references: [addresses.id],
    }),
    created: one(user, {
        fields: [customers.createdBy],
        references: [user.id],
    }),
}));
//# sourceMappingURL=customers.js.map